/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Example_UiInputs */

const en_mk_team_example_ui = /** @type {(inputs: Mk_Team_Example_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 1 · Page interface`)
};

const id_mk_team_example_ui = /** @type {(inputs: Mk_Team_Example_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 1 · Tampilan halaman`)
};

/**
* | output |
* | --- |
* | "Agent 1 · Page interface" |
*
* @param {Mk_Team_Example_UiInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_example_ui = /** @type {((inputs?: Mk_Team_Example_UiInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Example_UiInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_example_ui(inputs)
	return en_mk_team_example_ui(inputs)
});